"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseIcon = void 0;
const react_1 = __importDefault(require("react"));
const PauseIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: onClick }, props),
        react_1.default.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "white", fillOpacity: "0.4" }),
        react_1.default.createElement("rect", { x: "17", y: "16", width: "5", height: "16", fill: "white" }),
        react_1.default.createElement("path", { d: "M26 16H31V32H26V16Z", fill: "white" })));
};
exports.PauseIcon = PauseIcon;
